import { render, staticRenderFns } from "./BookingsAccommodationSums.vue?vue&type=template&id=62cb2484"
import script from "./BookingsAccommodationSums.vue?vue&type=script&lang=js"
export * from "./BookingsAccommodationSums.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports